module.exports = __webpack_public_path__ + "cef.9d120b72ac5a4f9d4e02c8082cd4cdb7.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/images/cef.png
// module id = ./frontend/images/cef.png
// module chunks = 1